import { createElement } from "react";

addEventListener('DOMContentLoaded', () => {
	// initializeOfferForm()
	const section = document.querySelector('section.insurance')
	if (!section) {
		return
	}

	let popup = document.getElementsByClassName('popup')[0]
	let contentPopup = popup.querySelectorAll('.content.single')[0]

	let closeButton = document.createElement('div')
	let popupContainer = document.createElement('div')
	closeButton.classList.add('close-button')
	popupContainer.classList.add('popup-container')
	popupContainer.appendChild(closeButton)
	popupContainer.appendChild(contentPopup)
	popup.appendChild(popupContainer)

	closeButton.addEventListener('click', () => {
		popup.classList.toggle('open')

	})

	const container = section.querySelector('.text-content')
	const items = Array.from(container.querySelectorAll('p')).map(el => el.textContent)
	container.innerHTML = ''

	const listContainer = document.createElement('div')
	listContainer.classList.add('insurance-list')
	container.appendChild(listContainer)
	
	const arrays = {}
	for (const item of items) {
		let firstLetter = item.trim()[0].toLowerCase()
		if (/^[0-9]/.test(firstLetter)) {
			firstLetter = '#'
		}

		arrays[firstLetter] = arrays[firstLetter] || []
		arrays[firstLetter].push(item)
	}

	const letters = Object.keys(arrays).sort()
	const totalColumns = 3
	const columnThreshold = Math.ceil(items.length / totalColumns)
	const columns = []
	let currentColumn = 0
	let itemsInColumn = 0

	for (const letter of letters) {
		
		columns[currentColumn] = columns[currentColumn] ?? {}
		columns[currentColumn][letter] = arrays[letter]
		itemsInColumn += arrays[letter].length

		if (itemsInColumn >= columnThreshold) {
			currentColumn += 1
			itemsInColumn = 0
		}
	}

	const groups = {} // Storing the <div> groups for performance.

	for (const [index, column] of columns.entries()) {
		let letters = Object.keys(column).sort()
		let columnElement = document.createElement('div')
		columnElement.classList.add(`column`,`column-${index}`)

		for (const letter of letters) {
			const group = document.createElement('div')
			group.id = 'letter-' + (letter == '#' ? 'number' : letter)

			const letterBefore = document.createElement('span')
			letterBefore.textContent = letter
			group.appendChild(letterBefore)
			const items = column[letter]
			for (const item of items) {
				const anchor = document.createElement('a')
				anchor.textContent = item
				anchor.classList.add('open-popup')
				group.appendChild(anchor)
				anchor.addEventListener('click', function () {
					let allDivs = listContainer.querySelectorAll('div')
					for (let i = 0; i < allDivs.length; i++) {
						allDivs[i].classList.remove('active');

					}
					anchor.parentNode.classList.add('active')
					let formInputInsurance = document.querySelectorAll('.insurance-field input')[0]
					formInputInsurance.value = anchor.textContent

					popup.classList.toggle('open')

					setTimeout(() => {
						anchor.parentNode.classList.remove('active')

					}, 2000);
				})
				group.appendChild(anchor)
			}

			groups[letter] = group
			columnElement.appendChild(group)
		}

		listContainer.appendChild(columnElement)

	}

	const search = (keywords) => {
		keywords = keywords.toLowerCase()

		for (const column of listContainer.children) {
			column.classList.toggle('hidden', keywords != '')
		}

		// Go through every group, check its contents if there are any items containing the text of the input.
		for (const group of Object.values(groups)) {
			let anyFound = false
			for (const item of group.children) {
				if (item instanceof HTMLAnchorElement) {
					const found = item.textContent.toLowerCase().includes(keywords) || keywords == ''
					item.classList.toggle('hidden', !found)
					anyFound = found || anyFound
				}
			}

			group.classList.toggle('hidden', !anyFound)
			if (anyFound) {
				group.parentElement.classList.remove('hidden')
			}
		}

	}

	const anchorsContainer = document.createElement('div')
	anchorsContainer.classList.add('alphabet-scrollto')
	container.insertBefore(anchorsContainer, listContainer)

	// Search field.
	{
		const searchButton = document.createElement('a')
		searchButton.classList.add('search')
		searchButton.addEventListener('click', () => {
			anchorsContainer.classList.toggle('search-mode')
			searchField.focus()
		})
		anchorsContainer.appendChild(searchButton)

		const searchContainer = document.createElement('div')
		searchContainer.classList.add('search-field')
		anchorsContainer.appendChild(searchContainer)

		const searchField = document.createElement('input')
		searchField.placeholder = 'Zoeken...'
		searchField.addEventListener('input', function (event) {
			search(this.value)
		})
		searchField.type = 'text'
		searchContainer.appendChild(searchField)

		const searchCloseButton = document.createElement('button')
		searchCloseButton.addEventListener('click', () => {
			anchorsContainer.classList.remove('search-mode')
			searchField.value = ''
			search('')
		})
		searchContainer.appendChild(searchCloseButton)
	}

	// Create letter anchors.
	const anchors = `#abcdefghijklmnopqrstuvwxyz`
		.split('')
		.map(letter => {
			const anchor = document.createElement('a')
			anchor.textContent = letter
			anchorsContainer.appendChild(anchor)
			
			if (!arrays[letter] || arrays[letter].length == 0) {
				anchor.classList.add('disabled')
			}
			else {
				anchor.href = '#letter-' + (letter == '#' ? 'number' : letter) // For a11y reasons.
				anchor.addEventListener('click', (event) => {
					event.preventDefault()
					event.stopImmediatePropagation()

					const group = groups[letter]
					const elementPosition = group.getBoundingClientRect().top

					scrollTo({
						behavior: 'smooth',
						top: elementPosition + scrollY - 100,
					})
					group.classList.add('active')

					setTimeout(() => group.classList.remove('active'), 2000)
				})
			}
		})
})